<template>
<div class="table-tdrow">
  <div class="table-td w200">
    {{payment.order_number}}
  </div>
  <div class="table-td w200">
    {{(payment.delivery_type ===1) ? 'FTL' : 'PTL'}}
  </div>
  <div class="table-td w200" >
    {{payment.vehicle_type.name}}
  </div>
  <div class="table-td w300" >
    {{payment.depot.name}}
  </div>
  <div class="table-td summary-action">
    {{calculateIndentTotal}}
  </div>
</div>
</template>

<script>
export default {
  components: {},
  props: {
    payment: Object,
    depotList: Array,
  },
  computed: {
    calculateIndentTotal() {
      const section = 'client';
      return this.payment.charges.reduce((total, value) => (total + Number(value.total_amount[section].toFixed(2))), 0);
    },
  },
};
</script>


<style lang="scss">
</style>
